module.exports = __webpack_public_path__ + "static/images/3518758d5019f6b2f810881e25f12048.png";